/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_Remove_UpvoteInputs */

const en_directory_card_remove_upvote = /** @type {(inputs: Directory_Card_Remove_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove product upvote`)
};

const zh_directory_card_remove_upvote = /** @type {(inputs: Directory_Card_Remove_UpvoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消点赞`)
};

/**
* | output |
* | --- |
* | "Remove product upvote" |
*
* @param {Directory_Card_Remove_UpvoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_remove_upvote = /** @type {((inputs?: Directory_Card_Remove_UpvoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Remove_UpvoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_remove_upvote(inputs)
	return zh_directory_card_remove_upvote(inputs)
});
export { directory_card_remove_upvote as "directory.card.remove_upvote" }